import requestInstance from "./Request";

const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/admin-api/v3`;

const serviceableZonesService = {
  // GET: Fetch all serviceable zones
  async getServiceableZones(params = {}) {
    try {
      const response = await requestInstance.get(`${BASE_URL}/serviceable-zones`, {
        params,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching serviceable zones:", error);
      throw error;
    }
  },

  // POST: Create a new serviceable zone
  async createServiceableZone(data) {
    try {
      const response = await requestInstance.post(`${BASE_URL}/serviceable-zones`, data);
      return response.data;
    } catch (error) {
      console.error("Error creating serviceable zone:", error);
      throw error;
    }
  },

  // PUT: Update an existing serviceable zone
  async updateServiceableZone(id, data) {
    try {
      const response = await requestInstance.put(`${BASE_URL}/serviceable-zones/${id}`, data);
      return response.data;
    } catch (error) {
      console.error("Error updating serviceable zone:", error);
      throw error;
    }
  },

  // DELETE: Delete a serviceable zone
  async deleteServiceableZone(id) {
    try {
      const response = await requestInstance.delete(`${BASE_URL}/serviceable-zones/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting serviceable zone:", error);
      throw error;
    }
  },
};

export default serviceableZonesService;
